export const LocalStorageKeys = {
    AccessToken: "access_token",
    CountryCode: "country_code",
    LatestMovies: "latest_movies",
    Affiliate: "affiliate",
    LoginAfter: "login_after"
}